<template>
    <div class="rubric-section-heading">
        <div class="rubric-section-content">
            <div class="title">
                {{ sectionIn.title }}
            </div>
            <div
                class="weight"
                v-if="rubricShowAdvancedOptions">
                <span class="label">{{ $t('rubrics.weight') }}</span
                >{{ sectionIn.weight }}
            </div>
        </div>

        <div class="rubric-section-heading-nav">
            <div class="nav-context">
                <b-dropdown
                    class="ellipsis-nav"
                    variant="primary"
                    right
                    toggle-class="text-decoration-none"
                    no-caret
                    menu-class="show-border"
                    boundary="window">
                    <template #button-content>
                        <i class="fas fa-fw fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                        class="edit edit-rubric"
                        v-b-modal="'update-rubric-section-heading-' + sectionIn.id"
                        href="#">
                        <i class="btn-edit"></i>{{ $t('common.edit') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        class="remove remove-rubric"
                        href="#"
                        @click="deleteSection(sectionIn)">
                        <i class="btn-remove"></i>{{ $t('common.delete') }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <design-2021-rubric-edit-section-heading-edit-modal-component
                :section-in="sectionIn"
                :rubric-show-advanced-options="rubricShowAdvancedOptions"
                :rubric-sections-in="rubricSectionsIn"
                ,>
            </design-2021-rubric-edit-section-heading-edit-modal-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-section-heading-component',
    props: {
        sectionIn: Object,
        rubricSectionsIn: Array,
        rubricShowAdvancedOptions: Boolean,
    },

    methods: {
        deleteSection: function (section) {
            this.alert
                .confirm(this.$t('rubrics.delete_section'), this.$t('rubrics.delete_section_confirmation_body'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();

                    this.axios.delete(this.routes.deleteRubricSection(section.id)).then(
                        (response) => {
                            section.remove();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.rubric-section-heading {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    font-size: $base-font-size;
    font-weight: $font-weight-medium;

    .rubric-section-heading-nav {
        margin-top: -#{map-get($grid-gutter-spacing, 'eight')};
    }

    .weight {
        font-size: $default-font-size;

        .label {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}
</style>
